import { render, staticRenderFns } from "./PerSwiper.vue?vue&type=template&id=9e973ae6&scoped=true&"
import script from "./PerSwiper.vue?vue&type=script&lang=ts&"
export * from "./PerSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./PerSwiper.vue?vue&type=style&index=0&id=9e973ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e973ae6",
  null
  
)

export default component.exports